import React from 'react'
import TextField from '@material-ui/core/TextField';
import star_icon from '../../assets/images/icons/star-icon.png'




const index = (props)=>{
    return(
        <div className="dashboard-textfield-container">
            <div className="dashboard-textfield-title">
                <span className="general-span-text">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
            <div className="dashboard-textfield-input">
                <TextField 
                    id="outlined-basic" 
                    label="" 
                    variant="outlined"
                    style={{width: '95%'}}
                    size="small"
                    onChange={props.handleChange}
                    value={props.value}
                    type={props.type}
                    required={true}
                    error={props.error}
                    helperText={props.helperText}
                    onBlur={props.onBlur}/>
            </div>
        </div>

    )
}

export default index